<template>
    <select class="form-select"
        :id="id"
        :name="name"
        v-model="selected">
        <option value="" disabled>{{placeHolderText}}</option>
        <option v-for="choice in choices" :key="choice.value" :value="choice.value">
            {{getTranslatedText(choice.text, 'fields.options') ?? choice.text}}
        </option>
    </select>
</template>
<script setup>
import { inject, computed } from 'vue';

const props = defineProps({
    choices: { type: Array, required: true },
    value: { type: [String, Number], default: '' },
    minlength: { type: [Number, String], default: undefined },
    maxlength: { type: [Number, String], default: undefined },
    type: { type: String, default: undefined },
    placeholder: { type: String, default: '' },
    id: { type: String, default: undefined },
    name: { type: String, required: true },
    label: { type: String, default: '' },
});
const emit = defineEmits(["update:model-value", "input"]);

const { getTranslatedText } = inject('app');

const placeHolderText = computed(() => {
    const placeholderText = props.placeholder && props.placeholder.length > 0 ? props.placeholder : '__select__';
    return getTranslatedText(placeholderText, 'fields.placeholders');
});

const selected = computed({
    get() { return props.value ?? ''; },
    set(v) { emit('input', v); }
});
</script>
